// @flow
import React from 'react';
import type { TileGridBlockData } from 'api/cms';
import { H3 } from 'components/Text';
import Box from 'components/Box';
import CardsBlock from './CardsBlock';

const TileGridBlock = ({
  data: { sections, imageSize },
  pageUrl,
  blockId
}: {
  data: TileGridBlockData,
  pageUrl: string,
  blockId: string
}) => (
  <>
    {sections.map((section, index) => (
      <Box mt={index > 0 && 48}>
        <H3>{section.name}</H3>
        <CardsBlock
          pageUrl={pageUrl}
          blockId={blockId}
          data={{
            imageSize,
            cards: section.tiles.map(tile => ({
              image: tile.thumbnail,
              headline: tile.heading,
              subheadline: tile.subHeading,
              text: `${tile.description.slice(0, 120)}${
                tile.description.length > 120 ? '...' : ''
              }`
            }))
          }}
        />
      </Box>
    ))}
  </>
);

export default TileGridBlock;
